module.exports = __webpack_public_path__ + "public/img/situationA.41a78270.png";